import script from "./PopupReviewMobileVideoSpeedMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewMobileVideoSpeedMenu.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewMobileVideoSpeedMenu.vue?vue&type=style&index=0&id=1d4bb6c7&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4bb6c7"]])

export default __exports__